import { Component, EventEmitter, inject, Input, OnDestroy, OnInit, Output, signal, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { SuperColumn, SuperTableComponent, TranslateService } from '@devinforius/super-compos-17';
import moment from 'moment';
import { ToastrService } from 'ngx-toastr';
import { TreeSelect } from 'primeng/treeselect';
import { ApiService } from 'src/app/core/services/api.service';
import { DataService } from 'src/app/core/services/data.service';
import { IContactService } from 'src/app/core/services/i-contact.service';
import { iAdminService } from 'src/app/core/services/iAdmin.service';
import { IDelibeGlobalService } from 'src/app/core/services/idelibe/global.service';
import { IDelibeManagementService } from 'src/app/core/services/idelibe/management.service';
import { IDelibeMeService } from 'src/app/core/services/idelibe/me.service';
import { Classeur } from 'src/app/shared/models/classeur';
import { IGlobalElements } from 'src/app/shared/models/common/IGlobalElements';
import { Global_Class } from 'src/app/shared/models/global';
import { PointParameters } from 'src/app/shared/models/global/point-parameters';
import { UserContact } from 'src/app/shared/models/iContact/user-contact';

import { MeRightsProfilPoint } from 'src/app/shared/models/me/rights-profil-point';
import { MeetingPaginated } from 'src/app/shared/models/meeting';
import { Point } from 'src/app/shared/models/point';
import { IAppConfiguration } from 'src/app/shared/models/response/IAppConfiguration';
import { TypeSeance } from 'src/app/shared/models/type_seance';
import { ServiceTreeUtils } from 'src/app/shared/utils/sercicesTree.utils';
import * as _ from 'underscore';
import * as async from 'async';
import { MeRightsManagementAdmin } from 'src/app/shared/models/admin/rights-management-admin';
import { DialogService } from 'primeng/dynamicdialog';
import { CreateClassementComponent } from './classement/create-classement.component';
import { SearchClassementComponent } from './search-classement/search-classement.component';
import { Chemise } from 'src/app/shared/models/chemise';
import { CreateFolderComponent } from './folder/create-folder.component';
import { UserInfo } from 'src/app/shared/models/user-info';
import { TenantInfo } from 'src/app/shared/models/tenant-info';
import { Router } from '@angular/router';
import { ClassementDossiers } from 'src/app/shared/models/global/classement-dossiers';
import { Code } from 'src/app/shared/models/code';
import { PointSeance, TypeSeanceRights } from 'src/app/shared/models/point/point-seance';
import { Observable, of, Subscription } from 'rxjs';
import { toPromise } from 'src/app/shared';
import { finalize, map, switchMap, tap } from 'rxjs/operators';
import { Status_Objets } from 'src/app/shared/models/status_objet';
import { ServicesService } from '@shared/services/services.service';
import { TreeNode } from 'primeng/api';
import { ServiceDto } from '@shared/interfaces/dtos/services';
import { TreeNodeSelectEvent } from 'primeng/tree';
import { SeanceLink } from '@shared/models/seanceLink';
import { DropdownChangeEvent } from 'primeng/dropdown';

interface AutoCompleteCompleteEvent {
  originalEvent: Event;
  query: string;
}

@Component({
  selector: 'app-infos-form',
  templateUrl: './infos-form.component.html',
  styleUrls: ['./infos-form.component.scss'],
})
export class InfosFormComponent implements OnInit, OnDestroy {
  private readonly iDelibeMeService: IDelibeMeService = inject(IDelibeMeService);
  private readonly iDelibeManagementService: IDelibeManagementService = inject(IDelibeManagementService);
  private readonly iDelibeGlobalService: IDelibeGlobalService = inject(IDelibeGlobalService);
  private readonly api: ApiService = inject(ApiService);
  private readonly translate = inject(TranslateService);
  private readonly dataS: DataService = inject(DataService);
  private readonly apiAdmin: iAdminService = inject(iAdminService);
  private readonly toastr: ToastrService = inject(ToastrService);
  private readonly iContactService: IContactService = inject(IContactService);
  private readonly dialogService: DialogService = inject(DialogService);
  private readonly router: Router = inject(Router);

  private readonly servicesService = inject(ServicesService);

  @ViewChild('serviceTreeSelect') treeSelect: TreeSelect;
  @ViewChild('superTableFilesDuplication') public superTableFilesDuplication: SuperTableComponent;

  @Input() public actualPoint: Point;
  @Input() public pointId: number;
  @Input() public userInfos: UserInfo;
  @Input() public appliedModelePoint;
  @Input() public statut: 'create' | 'update' | 'createFromIcourrier' | 'duplicate';

  @Output() updateButtons = new EventEmitter<any>();

  public globalElements;
  public infosForm = new FormGroup({
    objetSynthese: new FormControl(null, Validators.required),
    typeSeanceId: new FormControl(null, Validators.required),
    seanceId: new FormControl(null, Validators.required),
    serviceId: new FormControl(null, Validators.required),
    triService: new FormControl(null),
    iCourrierFichierIds: new FormControl<number[] | null>([]),
    typeId: new FormControl(null, Validators.required),
    confidentiel: new FormControl(),
    public: new FormControl(true),
    checkRgpd: new FormControl(),
    origine: new FormControl(),
    courrierId: new FormControl(),
    matiereId: new FormControl(),
    echevinatId: new FormControl(),
    agentTraitantIdiAdmin: new FormControl(),
    urgenceNiveauId: new FormControl(),
    classementId: new FormControl(),
    dossierClassementId: new FormControl(),
    folder: new FormControl(),
    dossierClassementDescription: new FormControl(),
    sleeve: new FormControl(),
    dossierClassement2Description: new FormControl(),
    statutId: new FormControl(null, Validators.required),
    typeDecisionId: new FormControl(),
    FichiersIds: new FormControl(null), //Only used in duplication. For other uses it's deleted
    RTFContent: new FormControl(null), //Only used in duplication. For other uses it's deleted,
    modelePointId: new FormControl(null),
    unlockPoint: new FormControl(),
  });

  service = new FormControl(null);
  public groupeSecuriteRightsPoints: MeRightsProfilPoint;
  public listOfStatuts: { label: string; value: number }[] = [];
  public listOfTypesSeances: { label: string; value: number }[] = [];
  public avoidChangeSeance: boolean = false;
  public seances: { label: string; value: number; date: number; verrouille: boolean }[] = [];
  public seanceSelectedInfos = null;
  public avoidChangeObjetType: boolean = false;
  public avoidChangeObjetTypeLabel = null;
  public serviceParent: Array<any> = [];
  public servicesParentChild: Array<any> = [];
  public selectedOption = null;
  public mandatoryPointParameters: PointParameters;
  public listOfEchevinats = [];
  public listOfEchevinatsRights = [];
  public listOfMatieres = [];
  public listOfTypePoint = [];
  public displayCourrierId = false;
  public duplication: boolean = false;
  public itemFiles = [];
  public openModalForFilesSelectionCourrier: boolean = false;
  public globalConfiguration: IAppConfiguration;
  public listeAgentsTraitantsAdmin: UserContact[] = [];
  public listeAgentsTraitantsAdminSearch: UserContact[] = [];
  public listOfCodesActives = [];
  public classeurs = [];
  public chemises = [];
  public rightsManagementAdmin: MeRightsManagementAdmin;
  public currentMeeting: any;
  public columnsFiles: SuperColumn[] = [
    {
      field: 'selected',
      header: 'Importé',
      format: (_, item) => {
        if (item.selected)
          return '<div class="d-flex justify-content-center"><i class="bi bi bi-check-circle-fill tac-status-icon mr-2" style="color: var(--green-inforius); font-size: 20px"></i></div>';
      },
      visible: true,
      width: '35px',
      align: 'center',
    },
    {
      field: 'name',
      header: 'description',
      visible: true,
    },
    {
      field: 'extension',
      header: 'extension',
      visible: true,
    },
    {
      field: 'fileType',
      header: this.translate.instant('fileType'),
      format: (_, item) => {
        if (item.modeleId && item.extension.toLowerCase() === 'pdf') {
          return this.translate.instant('document');
        } else if (item.annexeNumero) {
          return this.translate.instant('annexN°') + ' ' + item.annexeNumero;
        } else {
          return this.translate.instant('associatedFile');
        }
      },
    },
    {
      field: 'dateUpload',
      header: 'Date de dépot',
      format: (value) => {
        if (value) {
          return moment(value).format('DD/MM/YYYY');
        }
      },
    },
  ];
  public readonly fetchingServices = signal<boolean>(false);
  private sub: Subscription | null = null;

  public get shouldMeetingsDropdownBeDisabled(): boolean {
    if (!this.infosForm.value.typeSeanceId) return true;
    else if (!this.seances.length) return true;
    else if (this.statut === 'update' && this.actualPoint && this.actualPoint?.seanceLink?.inclusDansSeance)
      return true;
    return false;
  }

  private manageSeanceIdState(): void {
    // Initialiser l'état
    this.updateSeanceIdState();

    // Réagir aux changements de typeSeanceId
    this.infosForm.get('typeSeanceId').valueChanges.subscribe(() => {
      this.updateSeanceIdState();
    });
  }

  private updateSeanceIdState(): void {
    const seanceIdControl = this.infosForm.get('seanceId');

    if (this.shouldMeetingsDropdownBeDisabled) {
      seanceIdControl.disable({ emitEvent: false });
    } else {
      seanceIdControl.enable({ emitEvent: false });
    }
  }

  public async ngOnInit(): Promise<void> {
    this.dataS.getCurrentMeeting.subscribe((meeting) => {
      this.currentMeeting = meeting;
    });

    this.manageSeanceIdState();

    await this.fetchProfilRightsByPointId();
    await this.getGlobalElements();
    await this.fetchGlobalPointParams();
    await this.fetchConfiguration();
    await this.fetchUserDataAdmin();
    await this.fetchRightsManagement();
    await this.getTenant();
    await this.fetchMeetingPointsRights();
    await this.fetchMeetingTypes();
    await this.fetchStatuses();
    await this.fetchServices();

    this.fetchServicesTree();

    if (this.statut === 'update' || this.statut === 'duplicate') {
      await this.fetchPoint();
    }

    if (this.statut === 'createFromIcourrier') {
      await this.fetchInfosCourrier();
    }

    if (this.statut === 'create' && this.currentMeeting) {
      this.fetchInfosSeance(this.currentMeeting);
    }
    this.populateFormService();
    this.infosForm.get('agentTraitantIdiAdmin').setValidators([this.agentAutocompleteValidator.bind(this)]);
  }

  ngAfterViewInit(): void {
    this.sub = this.infosForm.get('courrierId').valueChanges.subscribe({
      next: (courrierId) => {
        if (courrierId > 0) {
          this.itemFiles = [];
          this.filesHaveBeenSelected = false;
          this.openModalForFilesSelectionCourrier = false;
        }
      },
      error: (error) => console.info(error),
    });
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  getTenant(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.apiAdmin.getTenant().subscribe(
        (res: TenantInfo) => {
          res.applications?.map((x) => {
            if (x.name === 'iCourrier') {
              this.displayCourrierId = true;
            }
          });
          resolve();
        },
        () => {
          this.toastr.error('Une erreur est survenue dans la récupération du tenant!');
          reject();
        }
      );
    });
  }

  private async fetchServices(): Promise<void> {
    const thisMeetingType = this.meetingTypesOptions.find(
      (meetingType) => meetingType.id === this.actualPoint?.typeSeanceId
    );
    const thisMeetingTypeRights = this.meetingPointsRights.typeSeanceRights.find(
      (right) => right.typeSeanceId === thisMeetingType?.id
    );
    const shouldFetchMyOwnServices = !thisMeetingTypeRights?.isGestionnaire;

    const req = shouldFetchMyOwnServices
      ? this.servicesService.fetchMyOwnServices()
      : this.servicesService.fetchServices();

    this.fetchingServices.set(true);

    const services = await toPromise(
      req.pipe(
        map((res) => ServiceTreeUtils.toTreeNodes(res)),
        finalize(() => this.fetchingServices.set(false))
      )
    );

    if (!services) {
      this.servicesOptions.set([]);
      return;
    }

    this.servicesOptions.set(services);
  }

  fetchGlobalPointParams(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.iDelibeGlobalService.getGlobalPointParameters().subscribe({
        next: (res: PointParameters) => {
          this.mandatoryPointParameters = res;
          if (res.echevinatObligatoire && this.infosForm.get('echevinatId')) {
            this.infosForm.get('echevinatId').setValidators([Validators.required]);
            this.infosForm.get('echevinatId').updateValueAndValidity();
          }
          if (res.classementObligatoire && this.infosForm.get('classementId')) {
            this.infosForm.get('classementId').setValidators([Validators.required]);
            this.infosForm.get('classementId').updateValueAndValidity();
          }
          if (res.matiereObligatoire && this.infosForm.get('matiereId')) {
            this.infosForm.get('matiereId').setValidators([Validators.required]);
            this.infosForm.get('matiereId').updateValueAndValidity();
          }
          if (res.origineObligatoire && this.infosForm.get('origine')) {
            this.infosForm.get('origine').setValidators([Validators.required]);
            this.infosForm.get('origine').updateValueAndValidity();
          }
          if (res.typeDecisionObligatoire && this.infosForm.get('typeDecisionId')) {
            this.infosForm.get('typeDecisionId').setValidators([Validators.required]);
            this.infosForm.get('typeDecisionId').updateValueAndValidity();
          }
          if (res.urgenceObligatoire && this.infosForm.get('urgenceNiveauId')) {
            this.infosForm.get('urgenceNiveauId').setValidators([Validators.required]);
            this.infosForm.get('urgenceNiveauId').updateValueAndValidity();
          }
          resolve();
        },
        error: (err) => {
          reject(err);
        },
      });
    });
  }

  private meetingPointsRights: PointSeance = {} as PointSeance;

  private async fetchMeetingPointsRights(): Promise<void> {
    const meetingPointsRights = await toPromise(this.iDelibeMeService.getRightsPointsSeances());

    if (!Array.isArray(meetingPointsRights.typeSeanceRights)) return;

    this.meetingPointsRights = meetingPointsRights;
  }

  fetchProfilRightsByPointId(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.iDelibeMeService.getProfilRightsByPointID(this.actualPoint?.id ?? null).subscribe({
        next: (res: MeRightsProfilPoint) => {
          this.groupeSecuriteRightsPoints = res;
          resolve();
        },
        error: (err) => {
          reject(err);
        },
      });
    });
  }

  fetchRightsManagement(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.apiAdmin.getRightsManagement().subscribe({
        next: (res: MeRightsManagementAdmin) => {
          this.rightsManagementAdmin = res;
          resolve();
        },
        error: (err) => {
          reject(err);
        },
      });
    });
  }

  async fetchStatuses(alreadyPopulated: boolean = false): Promise<void> {
    const { changerStatutAllowedIds, changerStatut } = this.groupeSecuriteRightsPoints;

    const currentPoint: Point | undefined = this.pointId
      ? await toPromise(this.api.getPointByID(this.pointId))
      : undefined;

    if (this.statut === 'update' && currentPoint) {
      this.groupeSecuriteRightsPoints?.changerStatutAllowedIds.push(currentPoint.statutId);
    }

    this.iDelibeGlobalService
      .getGlobalAllPointsStatuts()
      .pipe(
        map((statuses) => {
          statuses = statuses.filter((status) => changerStatutAllowedIds.includes(status.id));

          statuses = statuses.filter((status) => status.utilisable || status.id === currentPoint?.statutId);

          return statuses;
        })
      )
      .subscribe((statuts: Status_Objets[]) => {
        this.listOfStatuts = statuts.map((statut: Status_Objets) => ({
          label: statut.description,
          value: statut.id,
        }));

        if (alreadyPopulated) return;

        if (this.statut === 'create' || this.statut === 'duplicate') {
          const defaultStatus = statuts.find((s) => s.statutAutiliserLorsCreation);

          if (!defaultStatus) return;

          this.infosForm.patchValue({
            statutId: defaultStatus.id,
          });
        }

        if (this.statut === 'update') {
          this.infosForm.patchValue({ statutId: currentPoint.statutId });

          if (!changerStatut) {
            this.infosForm.controls.statutId.disable();
          }
        }
      });
  }

  private meetingTypesOptions: TypeSeance[] = [];

  async fetchMeetingTypes(): Promise<void> {
    this.meetingTypesOptions = [];

    const meetingsTypes = await toPromise(this.iDelibeGlobalService.getGlobalTypesSeances());

    if (!meetingsTypes) {
      this.toastr.error('Erreur lors de la récupération des types de séances');
      return;
    }

    this.meetingTypesOptions = meetingsTypes;

    this.listOfTypesSeances = meetingsTypes.map((seance: TypeSeance) => ({
      label: seance.description,
      value: seance.id,
    }));
  }

  clearTypeSeance(): void {
    this.infosForm.get('seanceId').setValue(null);
    this.seanceSelectedInfos = null;
    this.infosForm.get('seanceId').updateValueAndValidity();
  }

  displaySeanceSelected(): void {
    this.seanceSelectedInfos = this.seances.find((x) => x.value === this.infosForm.value.seanceId);
  }

  private setTypeFromMeetingType(): void {
    if (!this.currentMeeting) return;

    const currentMeetingType: TypeSeance = this.meetingTypesOptions.find(
      (meetingType) => meetingType.id === this.currentMeeting.typeSeanceId
    );

    if (!currentMeetingType || this.infosForm.value.typeId) return;

    this.infosForm.patchValue({
      typeId: currentMeetingType.defautObjetTypeId,
    });

    if (currentMeetingType.objetTypeNonModifiable && currentMeetingType.defautObjetTypeId) {
      this.infosForm.get('typeId').disable();
      return;
    }

    this.infosForm.get('typeId').enable();
  }

  private setTypeFromMeetingTypeChangeEvent(meetingTypeId: number): void {
    const selectedMeetingType = this.meetingTypesOptions.find((meetingType) => meetingType.id === meetingTypeId);

    if (!selectedMeetingType || this.infosForm.value.typeId) return;

    this.infosForm.patchValue({
      typeId: selectedMeetingType.defautObjetTypeId,
    });

    if (selectedMeetingType.objetTypeNonModifiable && selectedMeetingType.defautObjetTypeId) {
      this.infosForm.get('typeId').disable();
      return;
    }

    this.infosForm.get('typeId').enable();
  }

  private setTypeFromUpdatedPoint(): void {
    if (!this.actualPoint) return;

    const selectedMeetingType = this.meetingTypesOptions.find(
      (meetingType) => meetingType.id === this.actualPoint.typeSeanceId
    );

    if (!selectedMeetingType) return;

    this.infosForm.patchValue({
      typeId: this.actualPoint.typeId ?? selectedMeetingType.defautObjetTypeId,
    });

    if (selectedMeetingType.objetTypeNonModifiable && selectedMeetingType.defautObjetTypeId) {
      this.infosForm.get('typeId').disable();
      return;
    }

    this.infosForm.get('typeId').enable();
  }

  selectedMeetingPoint(meetingTypeChange: { value: number }, initialisation: boolean = true): void {
    if (!initialisation) {
      this.clearTypeSeance();
    }

    this.infosForm.get('typeId').enable();

    if (this.currentMeeting) {
      this.setTypeFromMeetingType();
    }

    if (this.actualPoint) {
      this.setTypeFromUpdatedPoint();
    }

    if (!this.actualPoint && !this.currentMeeting) {
      this.setTypeFromMeetingTypeChangeEvent(meetingTypeChange.value);
    }

    this.fetchMeeting(meetingTypeChange);
  }

  private verifyIfMeetingExitsInOptionsIfNotAddIt(): void {
    const { seanceLink } = this.actualPoint;

    if (!seanceLink) return;

    const formattedDate = moment(seanceLink.date, 'YYYYMMDD').format('DD/MM/YYYY');
    const meetingTypeLabel = this.listOfTypesSeances.find((x) => x.value === this.infosForm.value.typeSeanceId)?.label;

    const meetingAsOption: {
      label: string;
      value: number;
      date: number;
      verrouille: boolean;
    } = {
      label: seanceLink.description
        ? `${formattedDate} - ${seanceLink.description}`
        : `${meetingTypeLabel} - ${formattedDate}`,
      value: seanceLink.id,
      date: moment(seanceLink.date, 'YYYYMMDD').unix(),
      verrouille: seanceLink.verrouille,
    };

    this.seances = [meetingAsOption, ...this.seances];
  }

  public async fetchMeeting(event: { value: number }): Promise<void> {
    let currentTypeSeanceRight: TypeSeanceRights | undefined;

    if (this.meetingPointsRights.typeSeanceRights) {
      currentTypeSeanceRight = this.meetingPointsRights.typeSeanceRights.find((x) => x.typeSeanceId === event.value);
    }

    const actualTypeSeanceLabel = this.listOfTypesSeances.find(
      (x) => x.value === this.infosForm.value.typeSeanceId
    )?.label;

    const data = {
      TypeSeanceIds: [this.infosForm.value.typeSeanceId],
      DateDebut: moment().format('YYYY-MM-DD'),
      Cloture: false,
      pageSize: 500,
    };

    if (currentTypeSeanceRight?.isGestionnaire) {
      delete data.DateDebut;
      //le gestionnaire à accès à tout => les séances de n'imp quand + les ouvertes + les préparées
    }

    this.api.getMeetingsSearch(data).subscribe({
      next: (data: MeetingPaginated) => {
        moment.locale(localStorage.getItem('lang')); //* Setting the moment lang of component

        this.seances = [];
        data.items
          .filter((item) => (this.statut === 'update' ? this.actualPoint.seanceId !== item.id : true))
          .map((x) => {
            const formattedDate = moment(x.date, 'YYYYMMDD').format('DD/MM/YYYY');
            const dateForOrdre = moment(x.date, 'YYYYMMDD').unix();
            this.seances.push({
              label: x.description
                ? formattedDate + ' - ' + x.description
                : actualTypeSeanceLabel + ' - ' + formattedDate,
              value: x.id,
              date: dateForOrdre,
              verrouille: x.verrouille,
            });
          });

        if (this.actualPoint || this.currentMeeting) {
          this.verifyIfMeetingExitsInOptionsIfNotAddIt();
        }

        if (this.statut !== 'duplicate') {
          if (this.seances.length === 1) {
            this.infosForm.patchValue({
              seanceId: this.seances[0].value,
            });
          }

          if (this.currentMeeting) {
            this.infosForm.patchValue({
              seanceId: this.currentMeeting.id,
            });
          }

          if (this.actualPoint) {
            this.infosForm.patchValue({
              seanceId: this.actualPoint.seanceLink.id,
            });
          }
        }

        this.displaySeanceSelected();
        this.updateSeanceIdState();
      },
      error: (err) => {
        console.error('ERROR FETCHING MEETINGS', err);
      },
    });
  }

  getGlobalElements(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.dataS.getGlobalElements.subscribe({
        next: (globalElements: IGlobalElements) => {
          this.globalElements = new Global_Class(globalElements);
          this.checkUserRightsToSeeGlobalElementsBasedOnGroupeSecurity();
          this.fetchListOfCodesActives();
          resolve();
        },
        error: (err) => {
          reject(err);
        },
      });
    });
  }

  private fetchServicesTree(): void {
    const thisMeetingType = this.meetingTypesOptions.find(
      (meetingType) => meetingType.id === this.actualPoint?.typeDecisionId
    );
    const thisMeetingTypeRights = this.meetingPointsRights.typeSeanceRights.find(
      (right) => right.typeSeanceId === thisMeetingType?.id
    );

    ServiceTreeUtils.handleServices(this.apiAdmin, !thisMeetingTypeRights?.isGestionnaire).subscribe((res) => {
      this.serviceParent = res.serviceParent;
      this.servicesParentChild = res.servicesParentChild;
    });
  }

  onShowTreeSelect(): void {
    if (this.selectedOption) {
      const aTags = document.getElementsByClassName('p-treenode-content');
      let found;
      if (aTags && aTags.length > 0) {
        for (let i = 0; i < aTags.length; i++) {
          if (aTags[i].textContent == this.selectedOption.label) {
            found = aTags[i];
            found.classList.add('p-highlight');
            break;
          }
        }
      }
    }
  }

  checkDisplayButtonUseTemplateModel(): void {
    //* firstly checking if we're basically in a creation 'cause ticket IDELIBE-602 asks in creation
    if (this.statut !== 'update') {
      this.updateButtons.emit(this.infosForm.value as any);
    }
  }

  checkUserRightsToSeeGlobalElementsBasedOnGroupeSecurity(): Promise<boolean> {
    return new Promise((resolve) => {
      if (
        this.groupeSecuriteRightsPoints?.changerMatiereAllowedIds &&
        this.groupeSecuriteRightsPoints?.changerMatiereAllowedIds.length > 0
      ) {
        this.listOfMatieres = this.globalElements.matieres_LV.filter((x) =>
          this.groupeSecuriteRightsPoints?.changerMatiereAllowedIds.includes(x.value)
        );
      }

      if (
        this.groupeSecuriteRightsPoints?.changerStatutAllowedIds &&
        this.groupeSecuriteRightsPoints?.changerStatutAllowedIds.length > 0
      ) {
        this.listOfStatuts = this.globalElements.statuts_points_LV.filter((x) =>
          this.groupeSecuriteRightsPoints?.changerStatutAllowedIds.includes(x.value)
        );
      }

      if (
        this.groupeSecuriteRightsPoints?.changerTypePointAllowedIds &&
        this.groupeSecuriteRightsPoints?.changerTypePointAllowedIds.length > 0
      ) {
        this.listOfTypePoint = this.globalElements.types_points_LV.filter((x) =>
          this.groupeSecuriteRightsPoints?.changerTypePointAllowedIds.includes(x.value)
        );
      }
      if (
        this.groupeSecuriteRightsPoints?.changerEchevinatAllowedIds &&
        this.groupeSecuriteRightsPoints?.changerEchevinatAllowedIds.length > 0
      ) {
        this.listOfEchevinatsRights = this.globalElements.echevinats_LV.filter((x) =>
          this.groupeSecuriteRightsPoints?.changerEchevinatAllowedIds.includes(x.value)
        );
      }
      resolve(true);
    });
  }

  onMatterChange(event: DropdownChangeEvent | { value: number }): void {
    if (!event.value) {
      this.listOfEchevinatsRights = this.globalElements.echevinats_LV.filter((x) =>
        this.groupeSecuriteRightsPoints?.changerEchevinatAllowedIds.includes(x.value)
      );

      return;
    }
    const foundAldermanship = this.globalElements.matieres_LV.find(
      (aldermanship) => aldermanship.value === this.infosForm.value.echevinatId
    );

    if (!foundAldermanship) {
      this.infosForm.patchValue({ echevinatId: null });
    }

    this.listOfEchevinatsRights = this.globalElements.echevinats_LV.filter((x) =>
      this.groupeSecuriteRightsPoints?.changerEchevinatAllowedIds.includes(x.value)
    );

    const selectedMatter = this.globalElements.matieres_LV.find((matter) => matter.value === event.value);

    if (!selectedMatter) return;

    if (!selectedMatter.item.echevinats.length) return;

    const filteredAldermanships = this.listOfEchevinatsRights.filter((aldermanship) =>
      (selectedMatter.item.echevinats as any[]).includes(aldermanship.value)
    );

    if (!filteredAldermanships.length) {
      this.listOfEchevinatsRights = this.globalElements.echevinats_LV.filter((x) =>
        this.groupeSecuriteRightsPoints?.changerEchevinatAllowedIds.includes(x.value)
      );
      return;
    }

    if (filteredAldermanships.length === 1) {
      this.infosForm.patchValue({ echevinatId: filteredAldermanships[0].value });
    }

    this.listOfEchevinatsRights = filteredAldermanships;
  }

  public searchingMailFiles = false;
  public filesHaveBeenSelected = false;
  public selectedMailFilesToImport: any[] = [];

  importFileFromCourrierId(shouldOpenModal = true): void {
    if (!this.infosForm.value.courrierId) return;

    this.searchingMailFiles = true;
    this.itemFiles = [];

    let pointFiles: any[] = [];

    this.itemFiles = [];
    this.infosForm.patchValue({
      iCourrierFichierIds: [],
    });
    this.selectedMailFilesToImport = [];
    this.superTableFilesDuplication!._selection = [];

    this.fetchPointFiles(this.actualPoint)
      .pipe(
        tap((res) => {
          pointFiles = res;
        }),
        switchMap(() => this.api.getIcourrierFiles(this.infosForm.value.courrierId))
      )
      .subscribe({
        next: (res: any[]) => {
          this.itemFiles = res;
          this.itemFiles.map((item) => {
            item['selected'] = pointFiles.some((file) => file.iCourrierFichierId === item.id);
            return item;
          });

          if (this.statut === 'createFromIcourrier') {
            this.selectedMailFilesToImport = this.itemFiles;
            this.filesHaveBeenSelected = true;

            this.infosForm.patchValue({
              iCourrierFichierIds: this.itemFiles.map((item) => item.id),
            });
          } else {
            this.selectedMailFilesToImport = this.superTableFilesDuplication!._selection;
            this.filesHaveBeenSelected = !!this.selectedMailFilesToImport.length;
          }

          this.searchingMailFiles = false;
          this.openModalForFilesSelectionCourrier = shouldOpenModal;
        },
        error: (err) => {
          this.searchingMailFiles = false;

          if (err?.error?.message && err?.error?.message === 'Mail not found') {
            this.toastr.error("Ce courrier n'a pas pu être retrouvé, veuillez vérifier son identifiant");
          } else if (err.status === 401) {
            this.toastr.error("Vous n'êtes pas autorisé à importer ce courrier");
          } else {
            this.toastr.error('Une erreur est survenue');
          }
        },
      });
  }

  fetchConfiguration(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.iDelibeGlobalService.getConfiguration().subscribe({
        next: (res: IAppConfiguration) => {
          this.globalConfiguration = res;
          resolve();
        },
        error: (err) => {
          reject(err);
        },
      });
    });
  }

  fetchUserDataAdmin(): Promise<void> {
    return new Promise((resolve, reject) => {
      if (!this.userInfos?.contactId) {
        console.warn('userInfos ou contactId non disponible');
        resolve();
        return;
      }

      this.iContactService.getUserWithDataAdmin().subscribe({
        next: (res: UserContact[]) => {
          this.listeAgentsTraitantsAdmin = res.filter((x) => x.active);

          const selectedAgent = this.listeAgentsTraitantsAdmin.find((x) => x.value === this.userInfos.contactId);

          if (selectedAgent) {
            this.infosForm.patchValue({
              agentTraitantIdiAdmin: selectedAgent,
            });
          }
          resolve();
        },
        error: (err) => {
          reject(err);
        },
      });
    });
  }

  searchUser(event: AutoCompleteCompleteEvent): void {
    this.listeAgentsTraitantsAdminSearch = this.listeAgentsTraitantsAdmin.filter((x) => {
      return x.label.toLowerCase().includes(event.query.toLowerCase());
    });
  }

  fetchListOfCodesActives(): void {
    this.listOfCodesActives = this.globalElements.classement_code_LV.filter((x) => {
      //ajoute aussi si le classement est celui du point comme cela s'il est inactif on l'ajoute quand même
      if (x.item.actif || (this.infosForm.value.classementId && this.infosForm.value.classementId === x.item.id)) {
        return x;
      }
    });
  }

  //* Trigger when the code is changed in general tab
  changeCode(folderId = null): Promise<boolean> {
    return new Promise((resolve) => {
      if (this.infosForm.value.classementId) {
        this.apiAdmin
          .getGlobalClasseurs({ classementId: this.infosForm.value.classementId, archived: false })
          .subscribe((data: Classeur[]) => {
            this.classeurs = [];
            async.eachSeries(
              data,
              (x: Classeur, next) => {
                this.classeurs.push({
                  label: x.description === '' ? this.translate.instant('noDescription') : x.description,
                  value: x.id,
                  archive: x.archive,
                });
                next();
              },
              () => {
                //S'il y a un folder id, on va vérifier qu'il est bien dans la liste
                if (folderId) {
                  if (this.classeurs.map((x) => x.value).indexOf(folderId) > -1) {
                    this.infosForm.patchValue({ folder: folderId, sleeve: null }); // Pas oublier de reset les données...
                  }
                } else {
                  this.infosForm.patchValue({ folder: null, sleeve: null }); // Pas oublier de reset les données...
                }
                resolve(true);
              }
            );
          });
      } else {
        resolve(true);
      }
    });
  }

  createClassement(): void {
    this.dialogService
      .open(CreateClassementComponent, {
        header: 'Créer un code de classement',
        width: '50%',
        baseZIndex: 10000,
        data: {
          serviceId: this.infosForm.value.serviceId,
          typeId: this.infosForm.value.typeId,
          pointId: this.actualPoint?.id ? this.actualPoint.id : null,
        },
      })
      .onClose.subscribe((code) => {
        if (code) {
          this.globalElements = [] as any;
          this.apiAdmin.getGlobalClassementCode().subscribe((res: Code[]) => {
            this.globalElements.classement_code_LV = res.map((code: any) => {
              code.label = code.code + ' - ' + code.description;
              code.value = code.id;
              return code;
            });
            this.listOfCodesActives = this.globalElements.classement_code_LV;
            this.infosForm.patchValue({
              classementId: code.id,
              folder: null,
              sleeve: null,
            });
            this.infosForm.updateValueAndValidity();
          });
        }
      });
  }

  getServiceIdValue(): number | null {
    const serviceId = this.infosForm.value.serviceId;
    if (typeof serviceId === 'number') {
      return serviceId;
    }
    if (serviceId && typeof serviceId === 'object' && 'id' in serviceId) {
      return serviceId.id;
    }
    return null;
  }

  searchClassements(): void {
    const serviceId = this.getServiceIdValue();
    this.dialogService
      .open(SearchClassementComponent, {
        header: 'Recherche',
        width: '50%',
        baseZIndex: 10000,
        data: {
          serviceId: serviceId,
        },
      })
      .onClose.subscribe((search) => {
        if (search?.classeurId) {
          this.infosForm.patchValue({ folder: search.classeurId });
        }
        if (search?.chemiseId) {
          this.infosForm.patchValue({ sleeve: search.chemiseId });
        }
        if (search?.classementId) {
          this.infosForm.patchValue({ classementId: search.classementId });
          this.changeCode(search.classeurId ? search.classeurId : null);
          setTimeout(() => {
            this.changeFolder(search.chemiseId ? search.chemiseId : null);
          }, 200);
        }
        this.infosForm.updateValueAndValidity();
      });
  }

  createFolder(type: 'folder' | 'sleeve'): void {
    this.dialogService
      .open(CreateFolderComponent, {
        header: type === 'folder' ? 'Créer une farde' : 'Créer une chemise',
        width: '50%',
        baseZIndex: 10000,
        data: {
          serviceId: this.infosForm.value.serviceId,
          code: this.infosForm.value.classementId,
          servicesList: this.serviceParent,
          listCode: this.listOfCodesActives,
          type: type,
          fardeId: this.infosForm.value.folder,
          userInfos: this.userInfos,
          rightAdmin: this.rightsManagementAdmin,
        },
      })
      .onClose.subscribe((codes) => {
        if (codes?.folder && codes?.type === 'folder') {
          this.globalElements.classeur_code_LV = [];
          this.apiAdmin
            .getGlobalClasseurs({ classementId: this.infosForm.value.classementId, archived: false })
            .subscribe((res: Classeur[]) => {
              this.globalElements.classeur_code_LV = res.map((code: any) => {
                code.label = code.description;
                code.value = code.id;
                return code;
              });
              this.classeurs = this.globalElements.classeur_code_LV;
              if (
                !this.infosForm.value.serviceId ||
                codes.folder.serviceProprietaireId === this.infosForm.value.serviceId
              ) {
                this.infosForm.patchValue({
                  folder: codes.folder.id,
                  sleeve: null,
                });
              }
              this.infosForm.updateValueAndValidity();
            });
        } else if (codes?.folder && codes?.type === 'sleeve') {
          this.apiAdmin
            .getGlobalChemises({ classeurId: this.infosForm.value.folder, archived: false })
            .subscribe((data: Chemise[]) => {
              this.chemises = data.map((x) => {
                return {
                  label: x.description === '' ? this.translate.instant('noDescription') : x.description,
                  value: x.id,
                };
              });
            });
          if (!this.infosForm.value.serviceId || codes.folder.serviceProprietaireId === this.infosForm.value.serviceId)
            this.infosForm.patchValue({
              folder: codes.folder.fardeId,
              sleeve: codes.folder.id,
            });
        }
        this.infosForm.updateValueAndValidity();
      });
  }

  //* Triggers when the folder is modified in general Tab
  changeFolder(sleeveId = null): Promise<boolean> {
    return new Promise((resolve) => {
      if (this.infosForm.value.folder) {
        this.apiAdmin
          .getGlobalChemises({ classeurId: this.infosForm.value.folder, archived: false })
          .subscribe((data: Chemise[]) => {
            this.chemises = [];
            async.eachSeries(
              data,
              (x: Chemise, next) => {
                this.chemises.push({
                  label: x.description === '' ? this.translate.instant('noDescription') : x.description,
                  value: x.id,
                  archive: x.archive,
                });
                next();
              },
              () => {
                //S'il y a une sleeveId, on va vérifier qu'elle est bien dans la liste
                if (sleeveId) {
                  if (this.chemises.map((x) => x.value).indexOf(sleeveId) > -1) {
                    this.infosForm.patchValue({ sleeve: sleeveId });
                  }
                } else {
                  this.infosForm.patchValue({ sleeve: null }); // Pas oublier de reset les données...
                }
                resolve(true);
              }
            );
          });
      } else {
        resolve(true);
      }
    });
  }

  setInfoForm(event): void {
    if (event) {
      if (event.typeSeanceId && this.listOfTypesSeances.map((x) => x.value).indexOf(event.typeSeanceId) > -1) {
        this.infosForm.patchValue({ typeSeanceId: event.typeSeanceId });
        this.infosForm.updateValueAndValidity();
      }
      if (event.objet) {
        this.infosForm.patchValue({ objetSynthese: event.objet });
      }
      if (event.matiereId && this.listOfMatieres.map((x) => x.value).indexOf(event.matiereId) > -1) {
        this.infosForm.patchValue({ matiereId: event.matiereId });
        this.onMatterChange({ value: event.matiereId });
      }

      if (event.defautObjetTypeId && this.listOfTypePoint.map((x) => x.value).indexOf(event.defautObjetTypeId) > -1) {
        this.infosForm.patchValue({ typeId: event.defautObjetTypeId });
      }
      if (event.classementId && this.listOfCodesActives.map((x) => x.value).indexOf(event.classementId) > -1) {
        this.infosForm.patchValue({ classementId: event.classementId });
        //Ensuite on va regarder s'il y a un classeur
        if (event.fardeId) {
          this.changeCode(event.fardeId).then(() => {
            //on va enfin vérifier s'il y a une chemise et que l'on a bien patché un classeur
            if (event.chemiseId && this.infosForm.value.folder) {
              this.changeFolder(event.chemiseId);
            }
          });
        }
      }
      if (
        event.decisionType &&
        this.globalElements?.decision_type_LV.map((x) => x.value).indexOf(event.decisionType) > -1
      ) {
        this.infosForm.patchValue({ typeDecisionId: event.decisionType });
      }
    }
  }

  agentAutocompleteValidator(control: FormControl) {
    const value = control.value;
    if (!value) {
      return null;
    }
    // Accepter soit un objet avec une propriété value, soit une valeur primitive
    if (typeof value === 'object' && value.value) {
      return null;
    }
    if (typeof value === 'number' || typeof value === 'string') {
      return null;
    }
    return { invalidAgent: true };
  }

  fetchInfosSeance(currentMeeting): Promise<void> {
    const currentTypeSeanceRight = this.globalElements.rightsPointsSeances.typeSeanceRights.find(
      (x) => x.typeSeanceId === currentMeeting.typeSeanceId
    );
    return new Promise((resolve) => {
      if (currentMeeting) {
        this.infosForm.patchValue({
          typeSeanceId: currentMeeting.typeSeanceId,
        });

        if (this.statut !== 'duplicate') {
          this.infosForm.patchValue({
            seanceId: currentMeeting.id,
          });
        }

        this.selectedMeetingPoint({ value: currentMeeting.typeSeanceId });

        setTimeout(() => {
          this.infosForm.patchValue({
            statutId: 1,
          });

          if (currentTypeSeanceRight && currentTypeSeanceRight.isGestionnaire) {
            this.infosForm.patchValue({
              statutId: 2,
            });
          }
        }, 0);
        resolve();
      }
    });
  }

  public readonly servicesOptions = signal<TreeNode[]>([]);
  public selectedService: any = null;

  public onServiceSelect(event: TreeNodeSelectEvent): void {
    this.infosForm.patchValue({
      serviceId: event.node.data.id,
    });

    this.service.patchValue({
      ...event.node,
    });

    if (this.statut !== 'update') {
      this.updateButtons.emit(this.infosForm.value as any);
    }
  }

  private populateFormService(): void {
    const thisMeetingType = this.meetingTypesOptions.find(
      (meetingType) => meetingType.id === this.actualPoint?.typeSeanceId
    );

    const thisMeetingTypeRights = this.meetingPointsRights.typeSeanceRights.find(
      (right) => right.typeSeanceId === thisMeetingType?.id
    );
    const shouldFetchMyOwnServices = !thisMeetingTypeRights?.isGestionnaire;

    const req = shouldFetchMyOwnServices
      ? this.servicesService.fetchMyOwnServices()
      : this.servicesService.fetchServices();

    this.fetchingServices.set(true);

    req
      .pipe(
        map((res) => ServiceTreeUtils.toTreeNodes(res)),
        finalize(() => this.fetchingServices.set(false))
      )
      .subscribe({
        next: (res) => {
          this.servicesOptions.set(res);

          const scopeThis = this;
          let foundService = null;

          this.servicesOptions().some(function recursive(service) {
            if (service.data.id === scopeThis.actualPoint?.serviceId) {
              foundService = service;
              return true;
            }

            return Array.isArray(service.children) && service.children.some(recursive);
          });

          if (!foundService) return;

          this.selectedService = foundService;
          this.displayServiceLabel(foundService);
          this.infosForm.patchValue({ serviceId: foundService.data.id });
        },
      });
  }

  private displayServiceLabel(serviceToDisplay: TreeNode<ServiceDto>): void {
    const treeSelect = this.treeSelect;

    if (!treeSelect) return;

    treeSelect.value = serviceToDisplay;
  }

  fetchPoint(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.api.getPointByID(this.pointId).subscribe({
        next: (point: Point) => {
          this.actualPoint = new Point(point, this.globalElements);
          this.importFileFromCourrierId(false);
          this.actualPoint.serviceLabel = this.globalElements.services_LV.find(
            (x) => x.value === this.actualPoint.serviceId
          )?.label;

          this.infosForm.patchValue({ ...this.actualPoint, statutId: null });

          this.populateFormService();
          this.fetchStatuses(false);

          if (this.infosForm.value.classementId) {
            this.changeCode();
          }
          if (this.infosForm.value.matiereId) {
            this.groupeSecuriteRightsPoints?.changerMatiereAllowedIds.push(this.infosForm.value.matiereId);
            this.onMatterChange({ value: this.infosForm.value.matiereId });
          }
          if (this.infosForm.value.agentTraitantIdiAdmin) {
            this.infosForm.patchValue({
              agentTraitantIdiAdmin: this.listeAgentsTraitantsAdmin.find(
                (x) => x.value === this.infosForm.value.agentTraitantIdiAdmin
              ),
            });
          }
          if (this.infosForm.value.echevinatId) {
            if (this.infosForm.value.matiereId) {
              const currentMatter = this.groupeSecuriteRightsPoints.changerMatiereAllowedIds.find(
                (x) => x === this.infosForm.value.matiereId
              );
              if (currentMatter > -1) {
                this.groupeSecuriteRightsPoints?.changerEchevinatAllowedIds.push(this.infosForm.value.echevinatId);
              } else {
                console.log(this.infosForm.value);

                this.infosForm.patchValue({ echevinatId: null });
              }
            }
          }
          if (this.infosForm.value.typeId) {
            this.groupeSecuriteRightsPoints?.changerTypePointAllowedIds.push(this.infosForm.value.typeId);
          }

          if (this.infosForm.value.dossierClassementId) {
            this.getClassement(this.infosForm.value.dossierClassementId);
          }

          if (this.statut === 'duplicate') {
            this.infosForm.patchValue({
              //IDELIBE-2024 : After a long discussion between Dev team leader and support team
              typeSeanceId: null,
              agentTraitantIdiAdmin: this.listeAgentsTraitantsAdmin.find((x) => x.value === this.userInfos.contactId),
            });
          }

          if (this.statut !== 'duplicate') {
            this.selectedMeetingPoint({ value: point.typeSeanceId }, false);
          }

          this.updateSeanceIdState();
          resolve();
        },
        error: (err) => {
          reject(err);
        },
      });
    });
  }

  private fetchPointFiles(point: Point): Observable<any[]> {
    if (!point || !point.id) return of([]);

    return this.api.getPointFiles(point.id);
  }

  async getClassement(classementId: number): Promise<void> {
    this.apiAdmin.getGlobalClassementById(classementId).subscribe(async (classement: ClassementDossiers) => {
      this.infosForm.patchValue({
        classementId: classement.classementId,
      });
      await this.changeCode();
      this.infosForm.patchValue({
        folder: classement.classeurId,
      });
      await this.changeFolder();
      this.infosForm.patchValue({
        sleeve: classement.chemiseId,
      });
    });
  }

  async fetchInfosCourrier(): Promise<void> {
    const icourrierID = +localStorage.getItem('iDelibe_icourrier_id_send');
    if (icourrierID > 0) {
      this.router.navigateByUrl('/private/points/create-from-icourrier');
      try {
        const res: any = await this.api.getIcourrierByIdData(icourrierID).toPromise();
        if (res) {
          const serviceFound = this.userInfos.services.find((x) => x === res.serviceProprietaireId);
          if (!serviceFound) {
            this.toastr.warning(
              "Le service propriétaire du courrier n'est pas dans la liste de vos services autorisés.",
              'Attention'
            );
          }

          this.infosForm.patchValue({
            courrierId: res.id,
            serviceId: res.serviceProprietaireId
              ? this.findServiceById(this.serviceParent, res.serviceProprietaireId)
              : null,
            objetSynthese: res.objet,
          });

          this.infosForm.patchValue({
            classementId: res.classementId,
          });
          await this.changeCode();
          this.infosForm.patchValue({
            folder: res.classeurId,
          });
          await this.changeFolder();
          this.infosForm.patchValue({
            sleeve: res.chemiseId,
          });

          setTimeout(() => {
            this.importFileFromCourrierId(false);
          }, 100);
          this.updateSeanceIdState();
        } else {
          this.toastr.error('La récupération des infos du courrier a échoué');
          this.router.navigateByUrl('/private/points');
        }
      } catch (err) {
        console.error(err);
        this.toastr.error('La récupération des infos du courrier a échoué');
        this.router.navigateByUrl('/private/points');
      }
    }
  }

  private findServiceById(tree: any[], id: number): any | null {
    for (const node of tree) {
      if (node.value === id) {
        return node;
      }
      if (node.children && node.children.length > 0) {
        const found = this.findServiceById(node.children, id);
        if (found) {
          return found;
        }
      }
    }
    return null;
  }

  public importSelectedFiles(): void {
    this.selectedMailFilesToImport = this.superTableFilesDuplication?._selection ?? [];

    this.infosForm.patchValue({
      iCourrierFichierIds: this.selectedMailFilesToImport.map((item) => item.id),
    });

    this.filesHaveBeenSelected = true;
  }

  public updateImportedFilesFromMail(): void {
    this.importFileFromCourrierId();
  }
}
